import { useCallback, useEffect, useRef, useState } from 'react';
import Loader from '../Common/Loader';
import { Client } from '../../Models/Client';
import ClientApi from '../../Api/ClientApi';
import {
  APIProvider,
  ControlPosition,
  Map,
  useMapsLibrary,
} from '@vis.gl/react-google-maps';
import { ClusteredClientMarkers } from './ClusteredClientMarkers';
import { Button, TextInput } from 'flowbite-react';
import { CustomMapControl } from './CustomMapControl';

import './MapStyles.css';
import MapHandler from './MapHandler';

const center = {
  lat: 37.698,
  lng: -97.315,
};
export type AutocompleteMode = { id: string; label: string };

export default function DealerLocatorMap() {
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [clients, setclients] = useState<Client[]>([]);

  const getDealers = () => {
    setisLoading(true);
    ClientApi.GetDealerLocatorList()
      .then((res) => {
        if (res.data.length > 0) {
          setclients(res.data);
        }
        setisLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setisLoading(false);
      });
  };

  useEffect(() => {
    getDealers();
  }, []);

  const [placeAutocomplete, setPlaceAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address'],
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  // useEffect(() => {
  //   if (!placeAutocomplete) return;

  //   placeAutocomplete.addListener('place_changed', () => {
  //     onPlaceSelect(placeAutocomplete.getPlace());
  //   });
  // }, [onPlaceSelect, placeAutocomplete]);

  const autocompleteModes: Array<AutocompleteMode> = [
    { id: 'classic', label: 'Google Autocomplete Widget' },
    { id: 'custom', label: 'Custom Build' },
    { id: 'custom-hybrid', label: 'Custom w/ Select Widget' },
  ];

  const [selectedAutocompleteMode, setSelectedAutocompleteMode] =
    useState<AutocompleteMode>(autocompleteModes[0]);

  const [selectedPlace, setSelectedPlace] =
    useState<google.maps.places.PlaceResult | null>(null);

  return (
    <div className='w-full mt-4'>
      <div className='container mx-auto p-2'>
        <div className='mb-2 border-b-2'>
          <h1 className='text-gray-900 font-bold text-4xl'>Dealer Locator</h1>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          {!isLoading && (
            <div className='h-[calc(100vh-193px)] lg:h-[calc(100vh-266px)]'>
              <APIProvider apiKey={'AIzaSyCrvnTu7-hvvdXhQc8pPIj-t9OVBjcEzBc'}>
                <Map
                  mapId={'asdf'}
                  style={{
                    margin: 'auto',
                    width: '100%',
                    height: '100%',
                  }}
                  defaultCenter={center}
                  defaultZoom={6}
                  gestureHandling={'greedy'}
                  disableDefaultUI
                >
                  {<ClusteredClientMarkers clients={clients} />}
                </Map>
                <CustomMapControl
                  controlPosition={ControlPosition.TOP}
                  selectedAutocompleteMode={selectedAutocompleteMode}
                  onPlaceSelect={setSelectedPlace}
                />
                <MapHandler place={selectedPlace} />
              </APIProvider>
            </div>
          )}
          <div className='text-xs lg:text-base'>
            Price Brothers has hundreds of dealers across the United States and
            Canada. Use the map above to find a dealer in your area. If you need
            help finding a dealer or particular product, feel free to give us a
            call at 877-957-9577.
          </div>
        </div>
      </div>
    </div>
  );
}
